import { render, staticRenderFns } from "./ReviewActionsOrganizationOwnerCard.vue?vue&type=template&id=021b226b&scoped=true&lang=pug"
import script from "./ReviewActionsOrganizationOwnerCard.vue?vue&type=script&lang=js"
export * from "./ReviewActionsOrganizationOwnerCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewActionsOrganizationOwnerCard.vue?vue&type=style&index=0&id=021b226b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b226b",
  null
  
)

export default component.exports